import Header from './components/Header';
import Hero from './components/Hero';
import Ranking from './components/Ranking';
import Updates from './components/Updates';
import Media from './components/Media';
import Features from './components/Features';
import Topics from './components/Topics';
import Cards from './components/Cards';
import Carousel from './components/Carousel';
import Faq from './components/Faq';
import AppModule from './components/AppModule';
import Contact from './components/Contact';
import About from './components/About';
import Comments from './components/Comments';
import IndexModule from './components/IndexModule';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Ranking />
        <Updates />
        <Media />
        <Features />
        <Topics />
        <Cards />
        <Carousel />
        <Faq />
        <AppModule />
        <Contact />
        <About />
        <Comments />
        <IndexModule />
      </main>
      <Footer />
    </>
  );
}